import { createSlice } from "@reduxjs/toolkit";
import addTeleServicePrice from "../../../rtk-apis/Setting/addTeleServicePrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const addTeleServicePriceSlice = createSlice({
    name: "addTeleServicePriceSlice",
    initialState,
    reducers: {
        clearAddTeleServicePriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addTeleServicePrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(addTeleServicePrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(addTeleServicePrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.error = payload as any;
            });
    },
});

export default addTeleServicePriceSlice.reducer;
export const { clearAddTeleServicePriceState } = addTeleServicePriceSlice.actions;
